import {
    RequestConfigFunction,
} from 'app/types/request.types'

import {
    ValueMappingRequest,
} from './ValueMapping.types'

type ValueMappingRequests = {
    getValueMapping: RequestConfigFunction<ValueMappingRequest>
}

const requests: ValueMappingRequests = {
    getValueMapping: ({
        domain,
        data,
    }) => {
        return {
            url: `${domain}/spreadsheet/mapping-data`,
            method: 'POST',
            data,
        }
    },
}

export default requests
